import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

export const useSessionStorage = () => {
  const { currentAdmin, currentUser } = useDefaultAppContexts();
  const userId = currentAdmin?.id || currentUser?.id || 0;

  const set = (key: string, value: unknown): boolean => {
    try {
      sessionStorage.setItem(`hb-${key}-${userId}`, JSON.stringify(value));
      return true;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Failed to write to sessionStorage:', error);
      return false;
    }
  };

  const get = (key: string): unknown => {
    try {
      const value = sessionStorage.getItem(`hb-${key}-${userId}`);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Failed to read from sessionStorage:', error);
      return null;
    }
  };

  const remove = (key: string): boolean => {
    try {
      sessionStorage.removeItem(`hb-${key}-${userId}`);
      return true;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Failed to remove from sessionStorage:', error);
      return false;
    }
  };

  return {
    set,
    get,
    remove,
  };
};
